const reports = {
  users: {
    table: {
      users: 'User',
      login: 'Login',
      accessLevel: 'Access Level',
      activationDate: 'Activation Date',
      lastLogin: 'Last Login',
      status: 'Status',
    },
    search: 'User / Login',
    refreshButton: 'Search',
    resetButton: 'Reset',
    dateFilter: {
      activation: 'Activation date',
      lastLogin: 'Last login',
      notLogged: 'Not logged within',
    },
    statusFilter: {
      all: 'All Status',
      active: 'Active',
      inactive: 'Inactive',
    },
    allAccesslevel: 'All Access level',
  },
  cards: {
    table: {
      card: 'Credential',
      format: 'Format',
      username: 'Username',
      activationDate: 'Activation Date',
      lastUsed: 'Last Used',
      status: 'Status',
      assigned: 'Assigned',
      stolen: 'Stolen',
      lost: 'Lost',
      lockdown: 'Lockdown',
      usedForAccess: 'Used for Access',
    },
    cardSearch: 'Credential',
    usernameSearch: 'User',
    cardStatusRadio: 'Credential Status',
    cardOptionsRadio: 'Credential Options',
    allFormats: 'All Formats',
    cardStatusFilter: {
      all: 'All',
      active: 'Active',
      inactive: 'Inactive',
    },
    cardAssignedFilter: {
      all: 'All',
      yes: 'Yes',
      no: 'No',
    },
    dateFilter: {
      activation: 'Activation Date',
      lastUsed: 'Last Used',
      notUsed: 'Not Used In',
    },
  },
};

export default reports;
